var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconErrorComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? false : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'arco';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-error").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("rect", { x: "1", y: "1", width: "14", height: "14", rx: "7", fill: useCurrentColor ? 'currentColor' : '#E14653' }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.20891 9.94495L4.97212 10.1816C4.84312 10.3104 4.84312 10.5195 4.97212 10.6484L5.44607 11.122C5.57492 11.2507 5.78372 11.2507 5.91257 11.122L6.14974 10.885L7.99868 9.03756L9.86352 10.9009L10.1007 11.1379C10.2295 11.2666 10.4383 11.2666 10.5672 11.1379L11.0411 10.6643C11.1701 10.5354 11.1701 10.3263 11.0411 10.1974L10.8043 9.96083L8.93951 8.09749L10.8539 6.18465L11.0907 5.94805C11.2197 5.81916 11.2197 5.61007 11.0907 5.48117L10.6167 5.0076C10.4879 4.87885 10.2791 4.87885 10.1502 5.0076L9.91305 5.24457L7.99868 7.15741L6.10021 5.26045L5.86304 5.02348C5.73419 4.89473 5.52539 4.89473 5.39654 5.02348L4.92259 5.49705C4.79359 5.62595 4.79359 5.83504 4.92259 5.96393L5.15938 6.20053L7.05785 8.09749L5.20891 9.94495Z", fill: useCurrentColor ? 'currentColor' : '#fff' }));
}
var IconError = React.forwardRef(IconErrorComponent);
export default IconError;
